export const environment = {
    production: true,
    standardPriceId: 1,
    strategicPriceId: 2,
    manualPriceId: 3,
    scaniaUnitIdsForSLA: [26, 27, 28],
    missingSideMembersDB: ['MA', 'MS', 'MZ', 'MZK'],
    allocationBucketUrl: 'https://calsium-allocation-dev.s3-eu-west-1.amazonaws.com/index.html',
    currentEnvironment: 'dev', // this comes from Corporate-UI. Available options are dev,sys,pre,proto,prod
    msalConfig: {
        auth: {
            clientId: "83f533eb-75c0-4b9a-8205-ae7b6f63fe72",
            authority: "https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac",
            redirectUri: "",
            postLogoutRedirectUri: "http://localhost:4200",
            navigateToLoginRequestUrl: true
        },
        cache: {
            cacheLocation: 'sessionStorage' as 'sessionStorage' | 'localStorage',
            storeAuthStateInCookie: false
        }
    },
    protectedResources: {
        api: {
            endpoint: "https://listener.calsium.devtest.aws.scania.com/api",
            scopes: ['api://calsium-dev/calsium.read']
        }
    },
    loginRequest: {
        scopes: ['User.Read', 'api://calsium-dev/calsium.read']
    }
};
